import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, BookOpen, ShieldCheck, Lock, CreditCard, Star } from 'lucide-react';
import { scrollToPricing } from '../utils/scrollTo';
export const Hero = () => {
  return <section className="bg-sky-50 px-4 sm:px-6 lg:px-8 overflow-hidden flex flex-col justify-center min-h-[100svh] py-6 sm:min-h-0 sm:py-16 sm:pb-20 sm:block" data-id="element-45">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto text-center w-full" data-id="element-46">
        <div className="inline-block bg-teal-50 text-teal-800 font-semibold px-3 py-1 sm:px-4 sm:py-1.5 rounded-full text-xs sm:text-sm mb-3 sm:mb-6 border border-teal-100" data-id="element-47">
          KINESIOLOGÍA PRÁCTICA
        </div>
        <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight mb-3 sm:mb-8" data-id="element-48">
          <span className="text-slate-900" data-id="element-49">
            Dejá de improvisar en cada sesión.
          </span>
          <br data-id="element-50" />
          <span className="text-teal-700" data-id="element-51">
            Tu año de kinesiología, RESUELTO.
          </span>
        </h1>

        {/* Product Image Placeholder — between title and subtitle */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative mb-3 sm:mb-8" data-id="element-52">
          <img src="https://cdn.magicpatterns.com/uploads/dcXbEKEncJVg3XNqac6tEC/01c22960-f2f9-48bf-b6f6-900b8e91746a.png" alt="Megapack Kinesiología Práctica — Colección completa de 12 Tomos, 6 Bonus y 2 Ebooks Élite" width={512} height={512} loading="eager" fetchpriority="high" decoding="async" className="w-auto h-auto max-h-[28vh] sm:max-h-none mx-auto max-w-full sm:max-w-lg object-contain drop-shadow-2xl" data-id="element-53" />
        </motion.div>

        <h2 className="text-base sm:text-xl md:text-2xl font-bold text-teal-700 mb-2 sm:mb-4" data-id="element-54">
          Megapack Kinesiología Práctica — Pack Anual Elite Completo
        </h2>
        <p className="text-sm sm:text-lg text-slate-600 mb-4 sm:mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-55">
          El sistema completo de protocolos, plantillas y gestión clínica para
          el kinesiólogo independiente argentino.
        </p>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-4 sm:mb-8" data-id="element-56">
          <span className="flex items-center gap-1.5 bg-slate-100 text-slate-700 px-2.5 py-1 sm:px-3 sm:py-1.5 rounded-md text-xs sm:text-sm font-medium" data-id="element-57">
            📄 PDF
          </span>
          <span className="flex items-center gap-1.5 bg-slate-100 text-slate-700 px-2.5 py-1 sm:px-3 sm:py-1.5 rounded-md text-xs sm:text-sm font-medium" data-id="element-58">
            ⚡ Acceso Inmediato
          </span>
          <span className="flex items-center gap-1.5 bg-slate-100 text-slate-700 px-2.5 py-1 sm:px-3 sm:py-1.5 rounded-md text-xs sm:text-sm font-medium" data-id="element-59">
            📚 12 Tomos + 6 Bonus + 2 Élite
          </span>
        </div>

        <button onClick={scrollToPricing} className="w-full sm:w-auto bg-teal-700 hover:bg-teal-800 text-white text-base sm:text-lg md:text-xl font-bold py-3.5 sm:py-4 px-8 rounded-xl shadow-xl hover:shadow-2xl transform transition hover:-translate-y-1 inline-flex items-center justify-center gap-2" data-id="element-60">
          💪 QUIERO MI KINESIOLOGÍA PRÁCTICA AHORA
        </button>

        <div className="mt-4 sm:mt-6 flex flex-wrap justify-center items-center gap-3 sm:gap-4 text-xs sm:text-sm text-slate-500 font-medium" data-id="element-61">
          <span className="flex items-center gap-1" data-id="element-62">🛡️ Garantía 7 días</span>
          <span className="hidden sm:inline text-slate-300" data-id="element-63">|</span>
          <span className="flex items-center gap-1" data-id="element-64">🔒 Pago seguro</span>
          <span className="hidden sm:inline text-slate-300" data-id="element-65">|</span>
          <span className="flex items-center gap-1" data-id="element-66">
            💳 Tarjetas y transferencia
          </span>
        </div>
      </motion.div>
    </section>;
};
export const StatsBar = () => {
  return <div className="bg-teal-900 py-8 border-y border-teal-800" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center divide-y md:divide-y-0 md:divide-x divide-teal-800" data-id="element-69">
          <div className="flex flex-col items-center justify-center pt-4 md:pt-0" data-id="element-70">
            <p className="text-3xl font-extrabold text-white mb-1" data-id="element-71">+300</p>
            <p className="text-teal-200 font-medium" data-id="element-72">
              🇦🇷 kinesiólogos Argentina confían
            </p>
          </div>
          <div className="flex flex-col items-center justify-center pt-4 md:pt-0" data-id="element-73">
            <p className="text-3xl font-extrabold text-white mb-1" data-id="element-74">12+6</p>
            <p className="text-teal-200 font-medium" data-id="element-75">Tomos + Bonus</p>
          </div>
          <div className="flex flex-col items-center justify-center pt-4 md:pt-0" data-id="element-76">
            <p className="text-3xl font-extrabold text-white mb-1 flex items-center gap-2" data-id="element-77">
              4.9/5 <Star className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-78" />
            </p>
            <p className="text-teal-200 font-medium" data-id="element-79">⭐ calificación</p>
          </div>
        </div>
      </div>
    </div>;
};